import React, { useState } from "react";
import { ShieldAlert, LogOut } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "../../context/AuthContext";

export default function TermsGate() {
  const { user, acceptTerms, logout } = useAuth();
  const [checked, setChecked] = useState(false);
  const [busy, setBusy] = useState(false);

  const accept = async () => {
    if (!checked) return;
    setBusy(true);
    try {
      await acceptTerms();
      toast.success("Welcome aboard — access granted");
    } catch (_) {
      toast.error("Could not record acceptance. Try again.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen grid place-items-center p-6" style={{ background: "var(--bg)", color: "var(--text)" }} data-testid="terms-gate">
      <div className="w-full max-w-lg rounded-2xl p-7" style={{ background: "var(--panel)", border: "1px solid var(--border)" }}>
        <div className="flex items-center gap-3">
          <div className="grid place-items-center rounded-xl" style={{ width: 42, height: 42, background: "rgba(251,191,36,.12)", border: "1px solid rgba(251,191,36,.3)" }}>
            <ShieldAlert size={22} style={{ color: "var(--amber)" }} />
          </div>
          <div>
            <h2 className="text-lg font-bold">Terms of Use & Risk Disclaimer</h2>
            <p className="text-[12px]" style={{ color: "var(--text-dim)" }}>Signed in as {user?.email}</p>
          </div>
        </div>

        <div className="mt-5 rounded-xl p-4 max-h-56 overflow-y-auto text-[12.5px] leading-relaxed space-y-2.5"
          style={{ background: "var(--panel-2)", border: "1px solid var(--border)", color: "var(--text-muted)" }}>
          <p><strong style={{ color: "var(--text)" }}>1. No financial advice.</strong> YUMAERA TRADEPLAN provides analytical tools and generated trade setups for informational and educational purposes only. Nothing here is investment, financial, or trading advice.</p>
          <p><strong style={{ color: "var(--text)" }}>2. Trading risk.</strong> Trading cryptocurrencies involves substantial risk of loss and is not suitable for every investor. You may lose some or all of your capital. Past performance and generated setups do not guarantee future results.</p>
          <p><strong style={{ color: "var(--text)" }}>3. Your responsibility.</strong> All trading decisions are solely your own. You are responsible for evaluating the risks of any transaction.</p>
          <p><strong style={{ color: "var(--text)" }}>4. Data & access.</strong> This is a private workspace. Access is role-based and may be suspended by the workspace owner at any time. Do not share access.</p>
          <p><strong style={{ color: "var(--text)" }}>5. Acceptance.</strong> By continuing you confirm you have read and agree to these terms (v1.0).</p>
        </div>

        <label className="mt-5 flex items-start gap-2.5 cursor-pointer" data-testid="terms-checkbox-label">
          <input type="checkbox" data-testid="terms-checkbox" checked={checked} onChange={(e) => setChecked(e.target.checked)} className="mt-0.5" />
          <span className="text-[13px]" style={{ color: "var(--text-muted)" }}>I have read and accept the Terms of Use and Trading Risk Disclaimer.</span>
        </label>

        <div className="mt-6 flex items-center gap-3">
          <button
            data-testid="accept-terms-button"
            disabled={!checked || busy}
            onClick={accept}
            className="flex-1 h-11 rounded-xl font-semibold text-[14px] transition-opacity disabled:opacity-40"
            style={{ background: "linear-gradient(135deg,#8b5cf6,#6d28d9)", color: "#fff" }}
          >
            {busy ? "Saving…" : "Accept & Continue"}
          </button>
          <button
            data-testid="terms-logout-button"
            onClick={logout}
            className="h-11 px-4 rounded-xl font-medium text-[13px] flex items-center gap-2"
            style={{ background: "var(--panel-2)", border: "1px solid var(--border)", color: "var(--text-muted)" }}
          >
            <LogOut size={15} /> Sign out
          </button>
        </div>
      </div>
    </div>
  );
}
